import React from "react";
import { NumberInput } from "./NumberInput";

export const RejectLimitForm = ({
  formData,
  errors,
  onFieldChange,
  onSubmit,
  isSubmitting,
  t,
}) => {
  return (
    <form method="POST" className="kt-form">
      <div className="kt-form kt-form--label-right">
        <div className="kt-portlet__body">
          <NumberInput
            id="number_reject_max"
            label="Nombre de rejet toléré"
            value={formData.number_reject_max}
            onChange={(e) => onFieldChange("number_reject_max", e.target.value)}
            errors={errors.number_reject_max}
            required
            t={t}
          />
        </div>

        <div className="kt-portlet__foot">
          <div className="kt-form__actions text-right">
            {!isSubmitting ? (
              <button
                type="submit"
                onClick={onSubmit}
                className="btn btn-primary"
              >
                {t("Enregistrer")}
              </button>
            ) : (
              <button
                className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
                type="button"
                disabled
              >
                {t("Chargement")}...
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};
